import { action } from 'typesafe-actions';

import { ChangeKnoInPlanActionsEnum } from '../enums/ChangeKnoInPlanActionsEnum';
import { IKnoOrganisationChild } from '../../APIPackage/CatalogsModule/interfaces/IKnoOrganisationChild';
import { IPlanKnoChangeHistoryItem } from '../components/IPlanKnoChangeHistoryItem';
import { IKnmPlanFind } from '../../APIPackage/KnmModule/interfaces/IKnmPlanFind';

export const getErvkOrganisations = () => action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_GET);

export const setErvkOrganisationsSearchQuery = (searchQuery: string) =>
  action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET_SEARCH_QUERY, { searchQuery });

export const setErvkOrganisations = (knoOrganisations: IKnoOrganisationChild[]) =>
  action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET, {
    knoOrganisations,
  });

export const startProcessFormSubmit = (
  planData: IKnmPlanFind,
  stpNumber: string,
  ervkKnoOrganization: IKnoOrganisationChild,
) => action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_FORM_SUBMIT, { planData, stpNumber, ervkKnoOrganization });

export const changeKnoGetPlanHistoryChanges = () =>
  action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_PLAN_HISTORY_CHANGES_GET);

export const changeKnoSetPlanHistoryChanges = (historyItems: IPlanKnoChangeHistoryItem[]) =>
  action(ChangeKnoInPlanActionsEnum.CHANGE_KNO_PLAN_HISTORY_CHANGES_SET, {
    historyItems,
  });
